import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonApiService } from '../../../common-api.service';
import { SpeakerService } from '../../../speaker.service';
import { SnackbarService } from '../../../snackbar.service';
import { CommonDropdownService } from '../../../common-dropdown.service';
import { PaginatedDropdown } from '../../../util/paginated-dropdown';
import { DateRange } from '../../../util/date-range';
import { validateRequired } from '../../../util/validation.util';

@Component({
  selector: 'app-doctor-ledger',
  templateUrl: './doctor-ledger.component.html',
  styleUrls: ['./doctor-ledger.component.css']
})
export class DoctorLedgerComponent implements OnInit, OnDestroy {

  public range = new DateRange();
  public allData: any[] = [];
  public pdf_url: string;
  public disableDoctorSelection: boolean;

  public doctor: PaginatedDropdown;

  displayColumns = [
    'transaction_type',
    'transaction',
    'date',
    'debit_amount',
    'credit_amount',
    'running_balance',
    'narration',
  ];
  displayHeaders = [
    'Transaction Type',
    'Transaction',
    'Date',
    'Debit Amount',
    'Credit Amount',
    'Closing Balance',
    'Description/Narration',
  ];

  constructor(
    public speaker: SpeakerService,
    private api: CommonApiService,
    private snackbar: SnackbarService,
    private dropdownService: CommonDropdownService,
  ) {
    this.doctor = new PaginatedDropdown(this.api, this.dropdownService, 'doctor');
  }

  ngOnInit(): void {
    this.speaker.listData = this.allData;
    this.doctor.init();
  }

  ngOnDestroy() {
    this.speaker.showOpeningBalance = false;
    this.doctor.destroy();
  }

  getReportDetails(payload: any) {
    this.speaker.isLoading = true;
    this.api.callRoute('doctor', '/doctor_ledger', payload).subscribe({
      next: (res) => {
        this.speaker.isLoading = false;
        this.allData = res.data;
        this.speaker.listData = this.allData;
        this.speaker.openingBalance = res.opening_balance;
        this.speaker.showOpeningBalance = true;
        this.pdf_url = 'api/doctor/account_ledger_pdf?doctor_id=' + this.doctor.selectedId +
          '&start_date=' + this.range.start + '&end_date=' + this.range.end;
        if (this.allData.length == 0) {
          this.snackbar.info('No records found');
          return;
        }
      },
      error: () => { this.speaker.isLoading = false; }
    });
  }

  generateReport() {
    if (!this.range.validate(this.snackbar)) {
      return;
    }
    if (!validateRequired(
      [{ value: this.doctor.selectedId, label: 'doctor', allowZero: false }],
      this.snackbar,
    )) {
      return;
    }

    const payload = {
      doctor_id: this.doctor.selectedId,
      start_date: this.range.start,
      end_date: this.range.end,
    };

    this.speaker.listData = [];
    this.getReportDetails(payload);
    this.speaker.displayColumns = this.displayColumns;
    this.speaker.displayHeaders = this.displayHeaders;
  }
}
